export default {
    en: {
        id: 'diagram4c2-4',
        blocks: [
            {
                task: 'S = Domestic Bank’s strategy is to build an integrated system to support customer service, cut cots, provide timely management information.',
                title: "S = ",
                answer: 'Want to do X',
                modelName: 's'
            },
            {
                task: 'C = Can go about integration in two ways: develop a single, technically integrated system, or use best of breed products tied together in a cohesive manner.',
                title: "C = ",
                answer: 'Have alternative ways to do it',
                modelName: 'c'
            },
            {
                task: 'Q = (Which will we use?)',
                title: "Q = Which is best?",
                answer: ' ',
                disableEdit: true
            }
        ],
        title: 'Type in roughly what the Situation and Complication should say',
        note: 'You will note that the original document is structured around the analysis the writer conducted, going through the advantages and disadvantages of each approach.  You never want to show lists of advantages and disadvantages (or pros and cons) in your document.  You want to use those frameworks in doing your analysis, but you want to present only the results of the analysis to your reader, as we’ve done here.  There are generally three ways you can show the results, depending your data.'
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c2/practiceInSeeing3/i18n/exercise4.js